/**
 * 添加URL插件，用于一些常用的链接处理方法
 */

/**
 * 添加URL参数
 * @param {String} originUrl 原始链接
 * @param {Object} param 参数键值对,如：{p1: 1,p2: 2}
 * @return {String} url 拼装后的链接
 * @example
 *  appendParam('https://m.gamplus.qq.com', {p1: 1});
 *  appendParam('https://m.gamplus.qq.com?t1=1', {p1: 1});
 *  appendParam('https://m.gamplus.qq.com?t1=1&t2=2', {p1: 1});
 *  appendParam('https://m.gamplus.qq.com?t1=1&t2=2#s1=1', {p1: 1, p2: 2});
 * */
function appendParam(originUrl, param) {
  if (!param) {
    return originUrl;
  }
  let tmpUrl = originUrl;
  let tail = '';
  if (originUrl.indexOf('#') > 0) {
    tmpUrl = originUrl.split('#')[0];
    tail = `#${originUrl.split('#')[1]}`;
  }
  try {
    const gap = tmpUrl.indexOf('?') < 0 ? '?' : '&';
    const paramArr = [];
    Object.keys(param).forEach((item) => {
      paramArr.push(`${item}=${param[item]}`);
    });
    return `${tmpUrl}${gap}${paramArr.join('&')}${tail}`;
  } catch (e) {
    console.log('链接转化异常', originUrl, e);
    return originUrl;
  }
}

export {
  appendParam,
};
